import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  CheckCircleOutline,
  DoDisturbAlt,
  MoreVert,
  AddCircle,
  RemoveCircle,
  Edit,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  Delete,
  KeyboardReturn,
  Search,
} from "@mui/icons-material";
import {
  get_orders_detail,
  orders_edit_item,
  orders_add_item,
  orders_remove_item,
  get_inventory_by_customer,
  approve_order,
  reject_order,
  get_customer_return,
  manual_customer_return_order,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";

export default function ReturnList() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [page, setPage] = React.useState("order");

  const [loading, setLoading] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [itemData, setItemData] = React.useState([]);
  const [returnData, setReturnData] = React.useState([]);

  const getData = () => {
    setLoading(true);
    get_orders_detail({
      sales_order_id: params.sales_order_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setOrderData(json.data);

      manual_customer_return_order({
        sales_order_id: json.data.sales_order_id,
      }).then((json) => {
        if (json.status) {
        }
      });
    });
    get_customer_return({
      sales_order_id: params.sales_order_id,
      // sort: sort
    }).then((json) => {
      // setLoading(false);
      setReturnData(json.data);
    });
  };

  React.useEffect(() => {
    getData();
  }, []);

  const handleOpen = (e) => {
    console.log(e.item);
    setOpen(true);
    setItemData(e.item);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          <Navbar2
            children={
              <Section pd="2rem">
                {orderData != null && (
                  <React.Fragment>
                    <div>
                      <div
                        onClick={() => navigate(-1)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <Paragraph
                          color="#1A5386"
                          bold="400"
                          size="12px"
                          margin="0 0 1rem"
                        >
                          &lt; Back
                        </Paragraph>
                      </div>
                      <div className={classes.theFlexHeader}>
                        {/* <div className={classes.theHeaderSelect}>
                            <FormInput
                                // label="Username"f
                                textLabelColor="#000"
                                // placeholder="Username"
                                // name="username"
                                bold="600"
                                border="0"
                                size="24px"
                                value={location.pathname.replace(/[^A-Za-z]+/g, "")}
                                select
                                onChange={handleHeader}
                            >
                                <MenuItem value="sale">Sale Order</MenuItem>
                                <MenuItem value="invoice">Invoice</MenuItem>
                            </FormInput>
                        </div> */}
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Order Number:{" "}
                          {orderData.sales_order_id != "" &&
                          orderData.sales_order_id != null
                            ? orderData.sales_order_id
                            : "-"}
                        </Paragraph>

                        {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                                {returnData.length != 0 &&
                                                    <React.Fragment>
                                                        <a
                                                            className={classes.theCustomActionBtnFill}
                                                            onClick={() => navigate("/salereturn")}
                                                        >
                                                            <Search sx={{ color: "#fff" }} />
                                                            <Paragraph margin="0 0 0 .4rem">View Return</Paragraph>
                                                        </a>
                                                    </React.Fragment>
                                                }
                                                {orderData.status_id == 1 &&
                                                    <React.Fragment>
                                                        <a
                                                            className={classes.theCustomActionBtnFill}
                                                            onClick={() => handleApprove()}
                                                        >
                                                            <CheckCircleOutline sx={{ color: "#fff" }} />
                                                            <Paragraph margin="0 0 0 .4rem">Approve</Paragraph>
                                                        </a>
                                                        <a
                                                            className={classes.theCustomActionBtnFill_}
                                                            onClick={() => handleReject()}
                                                        >
                                                            <DoDisturbAlt sx={{ color: "#fff" }} />
                                                            <Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
                                                        </a>
                                                    </React.Fragment>
                                                }
                                                {orderData.status_id == 5 &&
                                                    <React.Fragment>
                                                        <a
                                                            className={classes.theCustomActionBtnFill}
                                                            onClick={() => handleOpenType()}
                                                        // onClick={() => navigate("/salereturn/" + orderData.sales_order_id)}
                                                        >
                                                            <KeyboardReturn sx={{ color: "#fff" }} />
                                                            <Paragraph margin="0 0 0 .4rem">Return</Paragraph>
                                                        </a>
                                                    </React.Fragment>
                                                }
                                            </div> */}
                      </div>
                      <div
                        style={{
                          borderBottom: "2px solid #707070",
                          padding: ".2rem 0",
                        }}
                      />
                      <br />
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Customer Name:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.entityid != "" &&
                                orderData.entityid != null
                                  ? orderData.entityid
                                  : "-"}
                              </Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Contact Number:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.phone != "" &&
                                orderData.phone != null
                                  ? orderData.phone
                                  : "-"}
                              </Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Email:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.email != "" &&
                                orderData.email != null
                                  ? orderData.email
                                  : "-"}
                              </Paragraph>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Payment Type:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.paymenttype}
                              </Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Currency:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.currency}
                              </Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">Syn Status:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.syn_status}
                              </Paragraph>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <div
                        style={{
                          borderBottom: "2px solid #707070",
                          padding: ".2rem 0",
                        }}
                      />
                      <br />
                      <Grid container spacing={3}>
                        {/* <Grid item xs={12} sm={12} md={6}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4} md={3}>
                                                <Paragraph size="14px">Invoice Address:</Paragraph>
                                            </Grid>
                                            <Grid item xs={12} sm={8} md={9}>
                                                <Paragraph size="14px" bold="600">

                                                </Paragraph>
                                            </Grid>
                                        </Grid>
                                    </Grid> */}
                        <Grid item xs={12} sm={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={3}>
                              <Paragraph size="14px">
                                Shipping Address:
                              </Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Paragraph size="14px" bold="600">
                                {orderData.addr1},
                              </Paragraph>
                              <Paragraph size="14px" bold="600">
                                {orderData.addr2},
                              </Paragraph>
                              <Paragraph size="14px" bold="600">
                                {orderData.city} {orderData.zip}{" "}
                                {orderData.state} {orderData.country}
                              </Paragraph>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Card className={classes.theCard}>
                            <div className={classes.theFlexHeader}>
                              <Paragraph size="14px" bold="600">
                                Return List
                              </Paragraph>
                            </div>
                            <br />
                            <div
                              style={{
                                borderBottom: "2px solid #707070",
                              }}
                            ></div>
                            <br />
                            <TableContainer>
                              <Table>
                                <TableHead style={{ backgroundColor: "#fff" }}>
                                  <TableRow>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Items
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Return Type
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "5%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Stock Return
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Return Reason
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "15%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Memo
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "15%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Others Reason
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Print RMA
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      className={classes.theHeadTitle_}
                                    >
                                      Print CN
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {returnData.map((item, index) => {
                                    return (
                                      <TableRow>
                                        {item.item.length == 0 ? (
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                          >
                                            -
                                          </TableCell>
                                        ) : (
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                            onClick={() => handleOpen(item)}
                                          >
                                            View all &#62;
                                          </TableCell>
                                        )}
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "15%",
                                          }}
                                        >
                                          {item.fullreturn == 1
                                            ? "All Item"
                                            : "Particular Item"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "5%",
                                          }}
                                        >
                                          {item.stockreturn == 0 ? "No" : "Yes"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "15%",
                                          }}
                                        >
                                          {item.reason}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "15%",
                                          }}
                                        >
                                          {item.description != ""
                                            ? item.description
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "15%",
                                          }}
                                        >
                                          {item.otherreason != ""
                                            ? item.otherreason
                                            : "-"}
                                        </TableCell>

                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "10%",
                                          }}
                                        >
                                          {item.rmalink != "" && (
                                            <Button
                                              label="Download RMA"
                                              bg="#265EA1"
                                              color="#fff"
                                              onClick={() =>
                                                window.open(item.rmalink)
                                              }
                                              style={{ marginRight: "14px" }}
                                              pd=".4rem 1rem"
                                              size="12px"
                                            />
                                          )}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#E0F0F7"
                                                : "#fff",
                                            width: "10%",
                                          }}
                                        >
                                          {item.cnlink != "" && (
                                            <Button
                                              label="Download CN"
                                              bg="#265EA1"
                                              color="#fff"
                                              onClick={() =>
                                                window.open(item.cnlink)
                                              }
                                              style={{ marginRight: "14px" }}
                                              pd=".4rem 1rem"
                                              size="12px"
                                            />
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Card>
                          <br />
                          <br />
                        </Grid>
                      </Grid>
                      <br />
                      <br />
                    </div>

                    <Dialog
                      onClose={handleClose}
                      open={open}
                      fullWidth="true"
                      maxWidth="md"
                    >
                      <DialogTitle>
                        <Paragraph
                          color="#1A5386"
                          bold="600"
                          size="24px"
                          center
                        >
                          Return Item List
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Card className={classes.theCard}>
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#fff" }}>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      width: "80%",
                                    }}
                                    className={classes.theHeadTitle_}
                                  >
                                    Items
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      width: "20%",
                                    }}
                                    className={classes.theHeadTitle_}
                                  >
                                    Quantity
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {itemData.map((item, index) => {
                                  return (
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                          width: "80%",
                                        }}
                                      >
                                        {item.itemname}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                          width: "20%",
                                        }}
                                      >
                                        {item.quantity}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Card>
                      </DialogContent>
                    </Dialog>
                  </React.Fragment>
                )}
              </Section>
            }
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
